module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2020_08.5f294382.jpg";